// extracted by mini-css-extract-plugin
export var attachment = "_pn-a";
export var emailContainer = "_pn-4";
export var emailContentPaddedContainer = "_pn-b";
export var emailHeader = "_pn-6";
export var emailIframe = "_pn-3";
export var emailInfoIcon = "_pn-9";
export var emailShortenedSummary = "_pn-e";
export var infoDropdown = "_pn-0";
export var infoRowBoundedContent = "_pn-d";
export var internal = "_pn-5";
export var merchant = "_pn-8";
export var messageInputContainer = "_pn-h";
export var normal = "_pn-7";
export var replyCard = "_pn-f";
export var subtleButton = "_pn-1";
export var subtleButtonIconContainer = "_pn-2";
export var toggleViewRepliesButton = "_pn-c";
export var wrappingText = "_pn-g";